function f(e, r, t) {
  return typeof e == "function" ? e(r, t) : e;
}
export {
  f as resolveComponentProps
};
//# sourceMappingURL=resolveComponentProps2.mjs.map
